// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___1FNK1","open":"open___29MjP","fullWidth":"fullWidth___1SzbS"};